import { FormEvent, useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { inviteApi } from '@/api/endpoints'
import { Button, Card, Field, Input } from '@/components/ui'

export default function InvitePage() {
  const { token = '' } = useParams()
  const navigate = useNavigate()
  const [email, setEmail] = useState<string | null>(null)
  const [invalid, setInvalid] = useState(false)
  const [password, setPassword] = useState('')
  const [password2, setPassword2] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [done, setDone] = useState(false)
  const [busy, setBusy] = useState(false)

  useEffect(() => {
    inviteApi
      .info(token)
      .then((i) => setEmail(i.email))
      .catch(() => setInvalid(true))
  }, [token])

  const submit = async (e: FormEvent) => {
    e.preventDefault()
    setError(null)
    if (password.length < 8) return setError('Heslo musí mít alespoň 8 znaků.')
    if (password !== password2) return setError('Hesla se neshodují.')
    setBusy(true)
    try {
      await inviteApi.redeem(token, password)
      setDone(true)
      setTimeout(() => navigate('/login', { replace: true }), 1500)
    } catch {
      setError('Pozvánku se nepodařilo uplatnit.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <Card className="w-full max-w-sm">
        <h1 className="mb-4 text-xl font-bold text-brand-700">Nastavení hesla</h1>
        {invalid ? (
          <div className="space-y-3">
            <p className="text-sm text-red-600">Pozvánka je neplatná nebo již byla použita.</p>
            <Link to="/login" className="text-sm text-brand-600 hover:underline">
              Zpět na přihlášení
            </Link>
          </div>
        ) : done ? (
          <p className="text-sm text-green-600">Hotovo! Přesměrování na přihlášení…</p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <p className="text-sm text-slate-500">
              Účet <span className="font-medium text-slate-700">{email ?? '…'}</span>
            </p>
            <Field label="Nové heslo">
              <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
            </Field>
            <Field label="Heslo znovu">
              <Input type="password" value={password2} onChange={(e) => setPassword2(e.target.value)} required />
            </Field>
            {error && <p className="text-sm text-red-600">{error}</p>}
            <Button type="submit" disabled={busy || !email} className="w-full">
              {busy ? 'Ukládám…' : 'Nastavit heslo'}
            </Button>
          </form>
        )}
      </Card>
    </div>
  )
}
